const DownloadIconCircle = ({
  width = 24,
  height = 24,
  style = {},
  className = "",
}) => {
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      style={style}
      className={className}
    >
      <circle
        cx="12"
        cy="12"
        r="12"
        fill="url(#paint0_linear_download)"
      />

      <path
        d="M12 6V13M12 13L8.5 9.5M12 13L15.5 9.5M7 16H17"
        stroke="white"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />

      <defs>
        <linearGradient
          id="paint0_linear_download"
          x1="12"
          y1="0"
          x2="7.64634"
          y2="25.315"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#F2674A" />
          <stop offset="1" stopColor="#FF9A85" />
        </linearGradient>
      </defs>
    </svg>
  );
};

export default DownloadIconCircle;